import React, { useEffect } from 'react';
import Route from 'routes';
import GlobalStyle from 'styles/globalStyle';
import { AppContextProvider } from './contexts/AppContext';
import { UIProvider } from './contexts/UIContext';
import TagManager from 'react-gtm-module/dist/TagManager';

const App = () => {
  const setScreenSize = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  useEffect(() => {
    setScreenSize();
    window.addEventListener('resize', setScreenSize);
  }, []);

  useEffect(() => {
    TagManager.initialize({
      gtmId: 'GTM-MTD4FQL3',
      // gtmId: process.env.REACT_APP_GTM_ID, // CRA 환경 변수 형식
    });
  }, []);

  return (
    <div className="App">
      <AppContextProvider>
        <UIProvider>
          <GlobalStyle />
          <Route />
        </UIProvider>
      </AppContextProvider>
    </div>
  );
};

export default App;
